namespace $ {
	export class $shm_hitalama_components_drafts_model extends $mol_object {
		definition() { return null as any as $shm_hitalama_map_widget_entity_custom }
		owner() { return this.$.$shm_hitalama_components_owner.definition( this.definition() ) }
		can_change() { return this.owner().can_change() }
		store() {
			const store = this.owner().Drafts_store()?.remote() ?? null
			if( store ) this.$.$shm_hitalama_map_component_ready.read( store )
			return store
		}
		ids() { return ( this.store()?.Entries()?.keys() ?? [] ).map( String ) }
		has( id: string ) { return this.ids().includes( id ) }
		title( id: string, next?: string ) {
			if( next !== undefined ) this.assert_change( id )
			return this.store()?.Entries()?.key( id )?.val( next ) ?? ''
		}
		entry( id: string ) {
			if( !this.has( id ) ) return null
			const entry = this.$.$giper_baza_glob.Pawn( new this.$.$giper_baza_link( id ), this.$.$shm_hitalama_components_drafts_entry )
			this.$.$shm_hitalama_map_component_ready.read( entry )
			return entry
		}
		text( id: string, next?: string ) {
			if( next !== undefined ) this.assert_change( id )
			const entry = this.entry( id )
			return entry?.Content( next === undefined ? undefined : null )?.value( next ) ?? ''
		}
		private assert_change( id?: string ) {
			if( !this.can_change() ) throw new Error( 'Нет прав на изменение черновиков приложения.' )
			if( id !== undefined && !this.has( id ) ) throw new Error( 'Черновик удалён. Выберите другой или создайте новый.' )
		}
		ensure_store( owner: $shm_hitalama_map_widget_entity_custom ) {
			const existing = owner.Drafts_store()?.remote()
			if( existing ) return existing
			if( !owner.can_change() ) throw new Error( 'Нет прав на создание черновиков приложения.' )
			const store = owner.land().area_make( $mol_hash_string( owner.link().str + ':application-drafts-v1' ) ).Data( this.$.$shm_hitalama_components_drafts_store )
			const previous = store.Owner()?.val()
			if( previous && previous !== owner.link().str ) throw new Error( 'Конфликт хранилища черновиков.' )
			store.Owner( null )!.val( owner.link().str )
			owner.Drafts_store( null )!.remote( store )
			return store
		}
		private operations = new WeakMap< object, { owner: $shm_hitalama_map_widget_entity_custom, date: string, entry?: $shm_hitalama_components_drafts_entry, published?: boolean } >()
		context( operation: object ) {
			let context = this.operations.get( operation )
			if( !context ) {
				context = { owner: this.owner(), date: new Date().toISOString() }
				this.operations.set( operation, context )
			}
			return context
		}
		allocate( owner: string ) {
			return this.$.$giper_baza_glob.Pawn( new this.$.$giper_baza_link( owner ), this.$.$shm_hitalama_map_widget_entity_custom )
				.land().area_make().Data( this.$.$shm_hitalama_components_drafts_entry )
		}
		@ $mol_action
		create( operation: object ) {
			const context = $mol_wire_sync( this ).context( operation )
			if( !context.owner.can_change() ) throw new Error( 'Нет прав на создание черновиков приложения.' )
			if( context.published ) return context.entry!.link().str
			const store = $mol_wire_sync( this ).ensure_store( context.owner )
			const entry = context.entry ??= $mol_wire_sync( this ).allocate( context.owner.link().str )
			const id = entry.link().str
			const entries = store.Entries( null )!
			if( entries.keys().includes( id ) ) { context.published = true; return id }
			entry.Created( null )!.val( context.date )
			entry.Content( null )!.value( '' )
			entries.key( id, null )!.val( '' )
			context.published = true
			return id
		}
		@ $mol_action
		remove( id: string ) {
			this.assert_change()
			this.store()?.Entries()?.cut( id )
		}
	}
}
